export default __webpack_public_path__ + "static/media/23-1.0f269e96.mp3";